//#region Libraries
import styled from "styled-components";
//#endregion

export const BodyRowText = styled.span`
    color: ${({ color = "var(--light-gray-5)" }) => color};
    font-size: 14px;
    font-weight: bold;
`;
export const StudentCell = styled.div`
    display: flex;
    align-items: center;
    width: 200px;
    & span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;
export const StateCell = styled.div`
    display: flex;
    justify-content: ${({ justify = "space-around" }) => justify};
    align-items: center;
    gap: 5px;
    position: relative;
`;
export const SelectionCell = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;